module.exports = __webpack_public_path__ + "img/1_2-macerie-1.4a947e80.png";